/**
 * Iniciais para o avatar de quem não tem foto cadastrada: primeira e última palavra do nome.
 *
 * <p>"Ana Souza" vira "AS", "Ana" vira "A". Nome vazio devolve string vazia — melhor o círculo em
 * branco do que duas letras inventadas de um nome que não veio.</p>
 */
export function iniciaisDoNome(nome?: string): string {
    const limpo = (nome ?? '').trim();
    if (!limpo) {
        return '';
    }
    const palavras = limpo.split(/\s+/);
    const primeira = palavras[0].charAt(0);
    const ultima = palavras.length > 1 ? palavras[palavras.length - 1].charAt(0) : '';
    return (primeira + ultima).toUpperCase();
}

/**
 * A foto pronta para o `src`, ou `null` quando não há foto.
 *
 * <p>O backend devolve o Base64 cru, sem o prefixo — e uma `<img src="/9j/4AAQ...">` não é imagem
 * quebrada: é uma requisição para um caminho relativo com aquele nome gigante, que volta 404 e
 * polui o console de todo mundo.</p>
 */
export function fotoComoDataUri(base64?: string | null): string | null {
    if (!base64) {
        return null;
    }
    return base64.startsWith('data:') ? base64 : `data:image/jpeg;base64,${base64}`;
}
